import { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { ProductSubType, ProductType } from '../type';
import { getSolarRecommand } from '@/service/solar-calculator';

const useGetProducts = (products: ProductType[]) => {
    const { locale } = useRouter();
    const [curProducts, setCurProducts] = useState(products);

    const handlerChangeProducts = (newProducts: ProductType[]) => {
        setCurProducts(newProducts);
    };

    // 调用接口获取产品信息
    const getAsynItem = useCallback(
        (item: ProductType) => {
            const newItem = JSON.parse(JSON.stringify(item)) as ProductType;
            const { productId, variantId } = newItem;
            return new Promise<ProductType | null>(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        if (res.data && typeof res.data === 'object' && Object.keys(res.data).length === 0) {
                            return resolve(null);
                        }

                        newItem.price = res?.data?.price;
                        newItem.compareAtPrice = res?.data?.compareAtPrice || res?.data?.price;
                        newItem.inventory = res?.data?.inventoryQuantity ?? 0;
                        if (!newItem?.img && res?.data?.variantImg) {
                            newItem.img = res?.data?.variantImg;
                        }
                        if (newItem?.subs?.length) {
                            const subs = (await Promise.all(newItem.subs.map((subItem) => getAsynItem(subItem)))).filter(Boolean) as ProductSubType[];
                            newItem.subs = subs;
                        }

                        return resolve(newItem);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        },
        [locale],
    );

    useEffect(() => {
        const promises = products?.map((item: ProductType) => getAsynItem(item));
        Promise.all(promises)
            .then((results) => setCurProducts(results.filter((item): item is ProductType => item !== null)))
            .catch((e) => {
                console.error(e);
            });
    }, [getAsynItem, products]);
    return {
        curProducts,
        handlerChangeProducts,
    };
};

export default useGetProducts;
